"use client";
import CustomSlider from "@/component/ui/CustomSlider/CustomSlider";
import Link from "next/link";
import { useEffect, useState } from "react";
import { CAROUSEL_SLIDER_PAD } from "../CarouselViewAll";
import ImageWrapper from "@/component/ui/ImageWrapper";

interface AuthorCard {
  name: string;
  image: string;
  profileUrl: string;
  OtherAuthorsLink?: string;
  slug?:string;
  username?:string;
}

interface OtherAuthorsProps {
  authors: AuthorCard[];
}

const gradientClasses = {
  orange: "bg-[linear-gradient(180.29deg,_#FFBF75_-67.23%,_#FFFFFF_65.75%)]",
  blue: "bg-[linear-gradient(180.29deg,_#7593FF_-67.23%,_#FFFFFF_65.75%)]",
  purple: "bg-[linear-gradient(180.29deg,_#A875FF_-67.23%,_#FFFFFF_65.75%)]",
};

const gradientColors: ("orange" | "blue" | "purple")[] = [
  "orange",
  "blue",
  "purple",
];

export default function OtherAuthors({ authors }: OtherAuthorsProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const AuthorCard = ({
    author,
    index,
  }: {
    author: AuthorCard;
    index: number;
  }) => {
    const gradient = gradientColors[index % gradientColors.length];

    return (
      <div className="w-full max-w-[170px] md:max-w-[160px] flex-none lg:min-w-0">
       <Link href={`/authors/${author.slug ?? author.username}`}>
          <div
            className={`
              ${gradientClasses[gradient]}
              flex h-full flex-col items-center justify-center rounded-[14px]
              border border-[#E5E7EB] px-[10px] pt-[25px] text-center
            `}
          >
            <div
              className="
                flex h-24 w-24 items-center justify-center overflow-hidden
                rounded-full border-[5px] border-white bg-[#F6F6F6]
                md:h-[96px] md:w-[96px]
              "
            >
              <ImageWrapper
                src={author.image}
                fallbackSrc={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}user-icon.svg`}
                alt={author.name}
                title={author.name}
                width={96}
                height={96}
                className="max-w-none object-cover w-[96px] h-[96px]"
              />
            </div>

            <h3
              className="
                mb-4 mt-[15px] line-clamp-2
                text-[14px] font-bold text-black
              "
            >
              {author.name}
            </h3>
          </div>
        </Link>
      </div>
    );
  };

  if (authors.length > 5) {
    return (
      <div className={CAROUSEL_SLIDER_PAD}>
      <CustomSlider
        responsive={{ desktop: 5.2, tablet: 2, mobile: 2 }}
        showArrows={true}
        itemsToShow={isMobile ? 2 : 5.2}
      >
        {authors.map((author, index) => (
          <AuthorCard key={index} author={author} index={index} />
        ))}
      </CustomSlider>
      </div>
    );
  }

  return (
    <>
      {authors.map((author, index) => (
        <AuthorCard key={index} author={author} index={index} />
      ))}
    </>
  );
}